import { uniqueId } from '@ember/helper';
import { on } from '@ember/modifier';
import type { TypedRecordInstance } from '@warp-drive/core/types/record';
import type { WithLegacy } from '@warp-drive/legacy/model/migration-support';

import { EditRecordBase } from './edit-record-base.gts';
import { ValidationMessage } from './validation.gts';

export function initialState(item: { id: string | null }): 'readonly' | 'edit' {
  if (item.id === null) {
    return 'edit';
  } else {
    return 'readonly';
  }
}

export class EditRecord<
  T extends WithLegacy<TypedRecordInstance>,
> extends EditRecordBase<T> {
  <template>
    {{#let (uniqueId) as |uniqueId|}}
      <form novalidate {{on "submit" this.submitClicked}} ...attributes>
        {{yield
          uniqueId
          this.isDisabled
          this.readonly
          this.validation
          this.cancelClicked
          to="form"
        }}

        <fieldset disabled={{this.saving}}>
          {{#if this.readonly}}
            {{#unless @hideValidationMessage}}
              <ValidationMessage @validation={{this.validation}} />
            {{/unless}}

            <div class="d-flex justify-content-center gap-2">
              {{#if this.canEdit}}
                <button
                  type="button"
                  class="btn btn-primary {{this.buttonSize}}"
                  {{on "click" this.editClicked}}
                  disabled={{@context.isEditing}}
                >{{@editLabel}}</button>
              {{/if}}
              {{yield uniqueId this.readonly this.validation to="buttons"}}
            </div>
          {{else}}
            {{#unless @hideValidationMessage}}
              <ValidationMessage @validation={{this.validation}} />
            {{/unless}}

            {{#if (has-block "buttons")}}
              <div
                class="d-flex justify-content-between gap-2"
                {{this.interceptTransition}}
              >
                <div class="d-flex justify-content-center gap-2">
                  {{yield uniqueId this.readonly this.validation to="buttons"}}
                </div>
                <div class="d-flex justify-content-center gap-2">
                  <button
                    type="button"
                    class="btn btn-outline-primary {{this.buttonSize}}"
                    {{on "click" this.cancelClicked}}
                  >{{this.cancelLabel}}</button>
                  <button
                    type="submit"
                    class="btn btn-primary {{this.buttonSize}}"
                  >{{this.saveLabel}}</button>
                </div>
              </div>
            {{else}}
              <div
                class="d-flex justify-content-center gap-2"
                {{this.interceptTransition}}
              >
                <button
                  type="button"
                  class="btn btn-outline-primary {{this.buttonSize}}"
                  {{on "click" this.cancelClicked}}
                >{{this.cancelLabel}}</button>
                <button
                  type="submit"
                  class="btn btn-primary {{this.buttonSize}}"
                >{{this.saveLabel}}</button>
              </div>
            {{/if}}
          {{/if}}
        </fieldset>
      </form>
    {{/let}}
  </template>
}
